import React from 'react';
import Text from "../components/ui/Text";

const Loading = () => {
    return (
        <div style={{
            flex: 1,
            display: 'flex',
            width: '100%',
            height: '100vh',
            alignItems: 'center',
            justifyContent: 'center'
        }}>
            <Text variant={'default_text'}>Loading...</Text>
        </div>
    );
};

export default Loading;
